import '../../src/App.css';
import '../../src/Css/bootstrap.min.css';
import Login from '../Pages/login';
// import HomePage from './pages/index';
import HomePage from "../Pages/index";
import Loader from 'react-loader-spinner';
import Menu from '../Components/Header/Menu';
import { useState, useEffect, Fragment } from 'react';
import PopupMenu from '../Components/PopupMenu';
import ModalDialog from '../Components/Modals/ModalDialog';
import MenuWide from '../Components/Header/MenuWide';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PrintViewer from "../Pages/PrintViewer";
import { getActiveSubsystems,  useIsMobileApp } from '../store/api/CommonFunctions';
import { useDispatch } from 'react-redux';
import SearchCommands from '../Pages/SearchCommands';
import { getAppConfig } from '../store/api/SystemSettingsAPI';
import UserDashboard from '../Pages/UserDashboard';
import ModalSMSTemplates from '../Components/Modals/ModalSMSTemplates';
import SearchSentSMS from '../Pages/SearchSentSMS';
import SearchReceivedSMS from '../Pages/SearchReceivedSMS';
import Disassembly from './pages/Disassembly';
import SearchDisassembly from "./pages/SearchDisassembly";
import BoM from './pages/BoM';
import SearchBoM from './pages/SearchBoM';

const requireAuth = (setUser) => {
  const token = localStorage.getItem('token');
  if (token !== null && token) {
    setUser(token);
  } else {
    setUser(null);
  }
}


function App(props) {
  const { setModalAboutUs, setQAList } = props;
  const dispatch = useDispatch();
  const isMobile = useIsMobileApp();
  const [pending, setPending] = useState(true);
  const [currentUser, setUser] = useState(null);
  const [menuWidth, setMenuWidth] = useState(false);
  const [forgetPassword, setForgetPassword] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem("UserInfo"));
  useEffect(() => {
    requireAuth(setUser);
    setPending(false);
    dispatch(getActiveSubsystems());
    dispatch(getAppConfig());

    document.getElementById("CompanyName")?.setAttribute("systemname", "سیستم تولید");
  }, []);
  return (
    <div className="App">
      <Router>
        {currentUser &&
          <Fragment>
            <ModalDialog />
            <PopupMenu />
            <div style={{ position: "relative", height: "max-content", display: "flex", paddingRight:"12px", paddingLeft:"12px" }}>
              {isMobile && !window.location.href.contains("SMSInvoice") && <Menu menuName="Sale" />}
              {!isMobile && !window.location.href.contains("SMSInvoice") &&
                <Fragment>
                  <span style={{ fontSize: "30px", cursor: "pointer", position: "relative"}} onClick={() => { setMenuWidth("250px") }}>&#9776;</span>
                  <MenuWide menuWidth={menuWidth} setMenuWidth={setMenuWidth} currentUser={currentUser} setModalAboutUs={setModalAboutUs} menuName="Production" setQAList={setQAList} />
                </Fragment>}
            </div>
            <Switch>
              <Route path="/PrintViewer/:reportName/:designMode"><PrintViewer /></Route>
              <Route path="/SearchCommands"><SearchCommands /></Route>
              <Route path="/UserDashboard"><UserDashboard /></Route>
              <Route path="/SMSTemplates"> <ModalSMSTemplates /></Route>
              <Route path="/SearchSentSMS"><SearchSentSMS /></Route>
              <Route path="/SearchReceivedSMS"><SearchReceivedSMS /></Route>
              <Route path="/Production/Disassembly/:id"><Disassembly /></Route>
              <Route path="/Production/SearchDisassembly"><SearchDisassembly /></Route>
              <Route path="/Production/BoM/:id/:type/:produceOne"><BoM /></Route>
              <Route path="/Production/SearchBoM"><SearchBoM /></Route>
              <Route path={userInfo?.HomePage === "Production" ? "/" : "/Production"}><HomePage /></Route>
            </Switch>
          </Fragment>
        }
        {pending &&
          <Loader type="BallTriangle"
            color="#bb1370"
            height={50}
            width={50} />}

        {!pending && !currentUser && !forgetPassword &&
          <Login setUser={setUser} setForgetPassword={setForgetPassword} />}
      </Router>
    </div>
  );
}

export default App;
